import {
  Flex,
  RadioGroup,
  Radio,
  Checkbox,
  Button,
  Text,
} from "@adobe/react-spectrum";

interface CallMonitorProps {
  monitorType: string;
  setMonitorType: (value: string) => void;
  isDisabled: boolean;
  handleCallMonitoring: () => void;
  muteStatus: boolean;
  setMuteStatus: (value: boolean) => void;
}

const CallMonitor: React.FC<CallMonitorProps> = (props) => {
  const {
    monitorType,
    setMonitorType,
    isDisabled,
    handleCallMonitoring,
    muteStatus,
    setMuteStatus,
  } = props;
  return (
    <>
      <Flex direction={"column"} height={"100%"}>
        <Text UNSAFE_className="call-detail-heading" marginY={15}>
          Join call as
        </Text>
        <RadioGroup
          orientation="horizontal"
          value={monitorType}
          onChange={setMonitorType}
          isEmphasized
          aria-label="Join call as"
          data-testid="join-call-as-radio-group"
        >
          <Radio
            value="silent"
            UNSAFE_className="call-monitor-text"
            isDisabled={isDisabled}
            aria-label="Silent monitor"
            data-testid="silent-monitor-radio"
          >
            Monitor
          </Radio>
          <Radio
            value="barge"
            UNSAFE_className="call-monitor-text"
            aria-label="Call barge in"
            data-testid="barge-in-radio"
            isDisabled={isDisabled}
          >
            Barge-in
          </Radio>
        </RadioGroup>
        <Checkbox
          aria-label="Mute me while joining the call"
          data-testid="mute-me-checkbox"
          isEmphasized
          isDisabled={monitorType === "barge" ? false : true}
          isSelected={muteStatus}
          UNSAFE_className="call-monitor-checkbox"
          onChange={setMuteStatus}
        >
          Mute me while joining the call
        </Checkbox>
        <Button
          aria-label="Submit request"
          data-testid="submit-call-monitor-btn"
          maxWidth={"125px"}
          onPress={handleCallMonitoring}
          variant="accent"
          UNSAFE_className={"submit-call-monitor-btn"}
          isDisabled={isDisabled}
        >
          Submit request
        </Button>
      </Flex>
    </>
  );
};

export default CallMonitor;
